module.exports = __webpack_public_path__ + "static/media/verifyLogo.cf544224.svg";